import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

//action

export const insertRetailerEntry = createAsyncThunk('insertRetailerEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=insertRetailerEntry`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});


export const updateRetailerEntry = createAsyncThunk('updateRetailerEntry', async (postData) => {

    try {
        const response = await axios.post(`${baseUrl}?apicall=updateRetailerMaster`, postData);
        return response.data;
    } catch (error) {
        throw error;
    }
});




export const fetchRetailerReg = createAsyncThunk('fetchRetailerReg', async (id) => {
    try {
        const endpoint = id ? `getRetailerRegister&rtId=${id}` : `getRetailerRegister`;
        const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});



export const deleteRetailerMaster = createAsyncThunk('deleteRetailerMaster', async (id) => {
    try {
        const response = await axios.delete(`${baseUrl}?apicall=deleteRetailerMaster&rtId=${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
});


const retailerApiSlice = createSlice({
    name: 'retailerData',
    initialState: {
        isLoading: false,
        redata: null,
        del: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(fetchRetailerReg.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchRetailerReg.fulfilled, (state, action) => {
            state.isLoading = false;
            state.redata = action.payload;
        });
        builder.addCase(fetchRetailerReg.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

        builder.addCase(deleteRetailerMaster.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(deleteRetailerMaster.fulfilled, (state, action) => {
            state.isLoading = false;
            state.del = action.payload;
        });
        builder.addCase(deleteRetailerMaster.rejected, (state, action) => {
            console.log('Error', action.error.message);
            state.isError = true;
        });

    }
});

export default retailerApiSlice.reducer;
